
import {
  Component,
  Prop,
  Mixins,
  Emit,
} from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Option,
  Button,
  Upload,
  Radio,
} from 'element-ui';
import { ISetting } from '@/types/set.d';
import api from '@/api/set';
import publicApi from '@/api/public';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    InputNumber,
    Select,
    Option,
    Button,
    Upload,
    Radio,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  private form: any = {
    categoryId: '',
    learningType: '0',
    learningNum: '',
    learningTime: '',
    standardHour: '',
  }

  private courseTypeList: any = []

  private classTypeList: any = [ // 开班形式
    { label: '1对1', value: 0 },
    { label: '1对多', value: 1 },
    { label: '无限制', value: 2 },
  ]

  private teachingTimeList: any = [ // 授课时长
    { label: '45-60', value: '45-60' },
    { label: '60', value: '60' },
    { label: '90', value: '90' },
    { label: '120', value: '120' },
    { label: '无限制', value: '无限制' },
  ]

  private standardTimeList: any = [ // 标准课时
    { label: '1', value: 1 },
    { label: '1.5', value: 1.5 },
    { label: '2', value: 2 },
    { label: '2.5', value: 2.5 },
    { label: '3', value: 3 },
  ]

  mounted() {
    // 获取课程类型
    api.getCourseType().then((res: any) => {
      this.courseTypeList = res.map((el:any) => ({ label: el.name, value: el.id }));
    });
    if (this.title.includes('编辑')) {
      this.form = {
        id: this.oldForm.id,
        categoryId: this.oldForm.categoryId,
        learningType: this.oldForm.learningType,
        learningNum: this.oldForm.learningNum,
        learningTime: this.oldForm.learningTime,
        standardHour: this.oldForm.standardHour,
      };
    }
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.resetForm();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑机构信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        if (title.includes('编辑')) { // 编辑数据
          this.form.id = this.oldForm.id;
          api.updateCourseConfig(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
            /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else { // 新增数据
          api.addCourseConfig(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
            /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
